import Home from './ComposedHome';
import HomeQuery from './HomeQuery.graphql';

Home.query = HomeQuery;

export default Home;
